import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"
import { ResponsiveTable, InfoModal } from "pharedata-responsive-components"

import { InputWithClearBtn } from "../../InputWithClearBtn"
import { SingleOption, customStyles, customStylesMobileModal, parseBudat, getLocaleStringNumber, getNumberFromLocalString, getLocaleStringFloat } from "../../utils/utils.js"
import { getAlertIconVentas } from "../../utils/get"
import { getMaterialTitleCierre } from "../../utils/materiales"
import { customModalStyles } from "../../utils/styles"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"

import closeIcon from "../../../assets/img/cross-icon.svg"
import errorIcon from "../../../assets/img/atencion_rojo.svg";

const styles = customModalStyles(20)
styles.content.padding = 0

const columnsMobile = [
  {"header": "ID Mov.", "key": "id", "showDetailArrow": false},
  {"header": "Tanque<br />Origen", "key": "tanqueOrigenLabel", "showDetailArrow": false},
  {"header": "Material", "key": "meterialStr", "showDetailArrow": true}
]

const columnsTablet = [
  {"header": "ID Mov.", "key": "id", "showDetailArrow": false},
  {"header": "Tanque Origen", "key": "tanqueOrigenLabel", "showDetailArrow": false},
  {"header": "Material", "key": "meterialStr", "showDetailArrow": true}
]

const modalColumns = [
  {"header": "Detalle Tanques", "key": "detalle", "showDetailArrow": false},
  {"header": "Cantidad", "key": "cantidad", "showDetailArrow": false}
]

export const MovimientosBodegaMobile = ({ 
  movimientosBodega, 
  getMaterialTitleCierre, 
  movimientoBodegaChange, 
  getTanquesDestinoRecomendados, 
  showAgregarButton,
  agregarMovimientoBodega,
  materialesTanques,
  getTanquesOrigen,
  getTanquesDestino,
  eliminarMovimientoBodega,
  checkStep,
  getTotalDiferencia,
  disableCalibraciones,
  selectedEstadoCierre,
  setStep,
  errores
}) => {
  const [dataForTable, setDataForTable] = useState([])
  const [editMovimientoKey, setEditMovimientoKey] = useState()
  const [editMovimiento, setEditMovimiento] = useState()
  const [newMovimiento, setNewMovimiento] = useState()

  useEffect(() => {
    if(movimientosBodega && movimientosBodega.length > 0){
      const newDataArr = []
  
      movimientosBodega.forEach(function(mov, key){
        const newData = JSON.parse(JSON.stringify(mov))
        newData.meterialStr = getMaterialTitleCierre(newData.material.value)
        newData.tanqueOrigenLabel = "Tanque " + (newData.tanqueOrigen? newData.tanqueOrigen.label: "")
        newDataArr.push(newData)
      })

      setDataForTable(newDataArr)
    }
    else{
      setDataForTable([])
    }
  }, [movimientosBodega])


  function agregarMovimiento(){
    agregarMovimientoBodega()
    setNewMovimiento(true)
    scrollTo(0, 0)
    showGreyBackground()
  }

  const closeModal = () => {
    setEditMovimientoKey()
    setEditMovimiento()
    setNewMovimiento(false)
    hideGreyBackground()
  }

  const closeNewMovimientoModal = () => {
    eliminarMovimientoBodega(movimientosBodega.length - 1)
    setNewMovimiento(false)
    hideGreyBackground()
  }

  const preEliminarMovimientoBodega = () => {
    const tmpEditMovimientoKey = editMovimientoKey
    setEditMovimientoKey()
    eliminarMovimientoBodega(tmpEditMovimientoKey)
    hideGreyBackground()
  }

  const showDetalle = (movimiento, key) => {
    setEditMovimiento(movimiento)
    setEditMovimientoKey(key)
    scrollTo(0, 0)
    showGreyBackground()
  }

  return (
    <div className="hide-desktop tablet-margin-top">
      <div className="big-subtitle">
        Movimientos de Bodega
        <hr className="title-separator-line" />
      </div>

      <div className="show-only-mobile">
        <ResponsiveTable 
          columns={columnsMobile}
          data={dataForTable}
          showDetailFunction={showDetalle}
          callDetailFunctionWithKey={true}
        />
      </div>

      <div className="show-only-tablet">
        <ResponsiveTable 
          columns={columnsTablet}
          data={dataForTable}
          showDetailFunction={showDetalle}
          callDetailFunctionWithKey={true}
        />
      </div>

      {
        errores.map((error) =>
        <div className="table-bottom-error" key={error}>
          <img src={errorIcon} alt="error" />
          <p>{error}</p>
        </div>
      )}
        
      {showAgregarButton() && 
        <div className="responsive-actions responsive-actions-tablet">
          <button className="main-button hallow mobile-button tablet-button" onClick={agregarMovimiento}>
            Agregar
          </button>
        </div>
      }
      {!showAgregarButton() && 
        <div>No se pueden agregar movimientos de bodega pues la EDS no cuenta con camión propio.</div>
      }

      <hr className="mobile-sections-separator" />
      <div className="responsive-actions responsive-actions-tablet">
        <button className="main-button mobile-button tablet-button" onClick={checkStep} disabled={getTotalDiferencia() !== 0 || disableCalibraciones || selectedEstadoCierre==="CERRADO"}>
          Confirmar
        </button>
        <button className="main-button hallow mobile-button tablet-button" onClick={() => setStep(2)}>
          Volver
        </button>
      </div>

      {(editMovimientoKey || editMovimientoKey === 0)&&
        <Modal isOpen={true} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Movimientos de Bodega</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            {!movimientosBodega[editMovimientoKey].nuevo &&
              <>
                ID
                <div className="mobile-disabled-input">
                  {movimientosBodega[editMovimientoKey].id}
                </div>
              </>
            }
            {movimientosBodega[editMovimientoKey].nuevo &&
              <>
                <div className="mobile-title-extra-space">
                  MATERIAL
                </div>
                <Select
                  className="eds-select cd-mb-select-last extra-margin-bottom-20"
                  value={movimientosBodega[editMovimientoKey].material}
                  onChange={(e) => movimientoBodegaChange(e, editMovimientoKey, 'material')}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  options={materialesTanques}
                  components={{ SingleOption, IndicatorSeparator: () => null }}
                  isClearable={false}
                  autosize={false}
                  placeholder="Seleccionar"
                  isSearchable={false}
                  styles={customStylesMobileModal}
                />
              </>
            }

            {movimientosBodega[editMovimientoKey].nuevo &&
              <>
                <div className="mobile-title-extra-space">
                  TANQUE ORIGEN
                </div>
                <Select
                  className="eds-select cd-mb-select-last extra-margin-bottom-20"
                  value={movimientosBodega[editMovimientoKey].tanqueOrigen}
                  onChange={(e) => movimientoBodegaChange(e, editMovimientoKey, 'tanqueOrigen')}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  options={getTanquesOrigen(editMovimientoKey)}
                  components={{ SingleOption, IndicatorSeparator: () => null }}
                  isClearable={false}
                  autosize={false}
                  placeholder="Seleccionar"
                  isSearchable={false}
                  styles={customStylesMobileModal}
                />
              </>
            }
            
            <div className="mobile-title-extra-space">
              SALIDA LITROS
            </div>
            {!movimientosBodega[editMovimientoKey].nuevo &&
              <div className="mobile-disabled-input">{editMovimiento.volumen}</div>
            }

            {movimientosBodega[editMovimientoKey].nuevo &&
              <input
                className="mobile-input"
                type="text" 
                onChange={(e) => movimientoBodegaChange(e.target.value, editMovimientoKey, 'volumen')} 
                value={movimientosBodega[editMovimientoKey].volumen} 
              />
            }

            <div className="mobile-title-extra-space">
              TANQUE DESTINO
            </div>
            {!movimientosBodega[editMovimientoKey].nuevo &&
              <Select
                className="eds-select cd-mb-select-last extra-margin-bottom-20"
                value={movimientosBodega[editMovimientoKey].tanqueDestino}
                onChange={(e) => movimientoBodegaChange(e, editMovimientoKey, 'tanqueDestino')}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                options={getTanquesDestinoRecomendados(editMovimientoKey)}
                components={{ SingleOption, IndicatorSeparator: () => null }}
                isClearable={false}
                autosize={false}
                placeholder="Seleccionar"
                isSearchable={false}
                styles={customStylesMobileModal}
              />
            }
            {movimientosBodega[editMovimientoKey].nuevo &&
              <Select
                className="eds-select cd-mb-select-last extra-margin-bottom-20"
                value={movimientosBodega[editMovimientoKey].tanqueDestino}
                onChange={(e) => movimientoBodegaChange(e, editMovimientoKey, 'tanqueDestino')}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                options={getTanquesDestino(editMovimientoKey)}
                components={{ SingleOption, IndicatorSeparator: () => null }}
                isClearable={false}
                autosize={false}
                placeholder="Seleccionar"
                isSearchable={false}
                styles={customStylesMobileModal}
              />
            }
          </div>
           
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Guardar
            </button>
            {movimientosBodega[editMovimientoKey].nuevo &&
              <button className="main-button main-button-red mobile-button" onClick={preEliminarMovimientoBodega}>
                Eliminar
              </button>
            }
          </div>
        </Modal>
      }

      {newMovimiento && movimientosBodega.length > 0 &&
        <Modal isOpen={newMovimiento} onRequestClose={closeNewMovimientoModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Agregar Mov. de Bodega</h1>
            <button className="mobile-filters__close-btn" onClick={closeNewMovimientoModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            <div className="mobile-title-extra-space">
              MATERIAL
            </div>
            <Select
              className="eds-select cd-mb-select"
              value={movimientosBodega[movimientosBodega.length - 1].material}
              onChange={(e) => movimientoBodegaChange(e, movimientosBodega.length - 1, 'material')}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={materialesTanques}
              components={{ SingleOption, IndicatorSeparator: () => null }}
              isClearable={false}
              autosize={false}
              placeholder="Seleccionar"
              styles={customStyles}
              isSearchable={false}
            />
            <div className="mobile-title-extra-space">
              TANQUE ORIGEN
            </div>

            <Select
              className="eds-select cd-mb-select-last regularizacion-table-select"
              value={movimientosBodega[movimientosBodega.length - 1].tanqueOrigen}
              onChange={(e) => movimientoBodegaChange(e, movimientosBodega.length - 1, 'tanqueOrigen')}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={getTanquesOrigen(movimientosBodega.length - 1)}
              components={{ SingleOption, IndicatorSeparator: () => null }}
              isClearable={false}
              autosize={false}
              placeholder="Seleccionar"
              styles={customStyles}
              isSearchable={false}
              disabled={true}
            />
            <div className="mobile-title-extra-space">
              SALIDA LITROS
            </div>

            <input
              className="mobile-input"
              type="text" 
              onChange={(e) => movimientoBodegaChange(e.target.value, movimientosBodega.length - 1, 'volumen')} 
              value={movimientosBodega[movimientosBodega.length - 1].volumen} 
            />

            <div className="mobile-title-extra-space">
              TANQUE DESTINO
            </div>

            <Select
              className="eds-select cd-mb-select-last"
              value={movimientosBodega[movimientosBodega.length - 1].tanqueDestino}
              onChange={(e) => movimientoBodegaChange(e, movimientosBodega.length - 1, 'tanqueDestino')}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={getTanquesDestino(movimientosBodega.length - 1)}
              components={{ SingleOption, IndicatorSeparator: () => null }}
              isClearable={false}
              autosize={false}
              placeholder="Seleccionar"
              styles={customStyles}
              isSearchable={false}
            />
          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Guardar
            </button>
          </div>
        </Modal>
      }

    </div>
  )
}
